// API Key Setup (Applicable only when cloning the repository)
// Our application relies on The Movie Database (TMDb) API to fetch movie and actor information. Follow these steps to set up your API key:
// To integrate your API key with the codebase, follow these steps:
// 1. Visit the TMDb website and create an account.
// 2. Once logged in, navigate to the API section in your account settings.
// 3. Generate a new API key.
// 4. Replace the exported string below with your TMDb API key

export default "f9cdeaf9af4ca30fda858745e2b12712";